// The Irrometer reading is an unsigned 12-bit ADC value. This value is first converted to ohms and then to pressure in Pascals (Pa). The conversion also requires temperature (in Celsius) which is taken from the average of the RIC temperature readings for the prior 24 hours. 24 C is used as a default value if no temperature readings exist. Convert the 12-bit value ($rdg in code below) to pressure ($prs in code below) using the following algorithm:

/*
$prs = 0.0;
if ( $rdg == 0xFFF )
{
  $prs = null; // display reading as “invalid”
}
else
{
  $rref = 10.0;
  $vref = 2.5;
  $dref = 2.5;
  $v3 = ($dref * (float)$rdg) / 4095.0;

  if ( $vref > $v3 ) {
    $res = ($rref * $v3) / ($vref - $v3);
  } else {
    $res = 1E6;
  }

  $tempC = $this->GetAverageTemperature (); // 24C is default

  if ( $res < 0.55 )
  {
    $cb = 0.0;
  }
  else if ( $res < 1.0 )
  {
    $cb = -20.0*($res*(1.0+(0.018*($tempC-24.0)))-0.55);
  }
  else if ( $res < 8.0 )
  {
    $cb = ((-3.213*$res)-4.093)/(1.0-(0.009733*$res)-(0.01205*$tempC));
  }
  else
  {
    $fct = 1.0+(0.018*($tempC-24.0));
    $cb = -2.246-(5.239*$res*$fct)-(0.06756*$res*$res*$fct*$fct);
  }

  $prs = abs($cb)*1000.0; // convert to pascals
}
*/

export function irrometer(
  reading: number,
  scale: number,
  offset: number,
  frequency: number
): number {
  const rref = 10.0
  const vref = 2.5
  const dref = 2.5
  const v3 = (dref * reading) / 4095.0

  const res = vref > v3 ? (rref * v3) / (vref - v3) : 1e6

  // const tempC = this->GetAverageTemperature(); // 24C is default
  const tempC = 24.0 // TODO: fix this (get average temperature) --> should be input into function

  var cb = 0.0

  if (res < 0.55) {
    cb = 0.0
  } else if (res < 1.0) {
    cb = -20.0 * (res * (1.0 + 0.018 * (tempC - 24.0)) - 0.55)
  } else if (res < 8.0) {
    cb = (-3.213 * res - 4.093) / (1.0 - 0.009733 * res - 0.01205 * tempC)
  } else {
    const fct = 1.0 + 0.018 * (tempC - 24.0)
    cb = -2.246 - 5.239 * res * fct - 0.06756 * res * res * fct * fct
  }

  return Math.abs(cb) * 1000.0 // convert to pascals
}
